import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaEdit } from "react-icons/fa";
import { Button } from 'react-bootstrap';

const selectedClient = (e) => {
  console.log(e.target.value);
}

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Client ID</th>
        <th style={{width:'50%'}}>Client Name</th>
        <th className='d-none d-sm-table-cell'>Contact Person</th>
        <th className='d-none d-sm-table-cell'>Phone</th>
        <th className='d-none d-md-table-cell'>Email</th>
        <th style={{width:'5%'}}>{props.mode==0?'Edit':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.clientsObj) {
    const rows = props.clientsObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.clientname}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.clientcontactperson}
          </td>        
          <td className='d-none d-sm-table-cell'>  
            {row.clientcontactphone}
          </td>   
          <td className='d-none d-md-table-cell'>  
            {row.clientcontactemail}
          </td>            
          <td>  
            {(props.mode==0) &&
              <Button><Link to = {`/editclientpage/${row.id}`}><FaEdit color='white'/></Link></Button>      
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                props.onSelected(row.id,row.clientname);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            }            
          </td>              
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const ClientsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} clientsObj={props.listOfClients} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default ClientsList;